import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home";
import StructureBased from "@/views/generation/StructureBased";
import Generation from "@/views/Generation";
import PharBased from "@/views/generation/PharBased";
import PropertyBased from "@/views/generation/PropertyBased";
import LinkerDesign from "@/views/generation/LinkerDesign";
import Optimization from "@/views/Optimization";
import Contact from "@/views/Contact";
import Tutorial from "@/views/Tutorial";
import Success from "@/views/Success";
import LogP from "@/views/optimization/LogP";
import Hydrophilic from "@/views/optimization/Hydrophilic";
import QED from "@/views/optimization/QED";
import SA from "@/views/optimization/SA";
import Result from "@/views/optimization/Result";
import Detail from "@/views/optimization/Detail";
import GenResult  from "@/views/generation/Result";
import GenDetail from "../views/generation/GenDetail";
import SequenceBased from "../views/generation/Sequence-based.vue"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
    },

    {
        path: '/generation',
        name: 'Generation',
        component: Generation,
        show: true,
        children: [
            {
                path: 'SBDD-3D',
                name: 'Structure-Based',
                component: StructureBased
            },
            {
                path: 'SequenceBased',
                name: 'SequenceBased',
                component: SequenceBased
            },
            {
                path: 'phar-based',
                name: 'Phar-Based',
                component: PharBased
            },
            {
                path: 'property-based',
                name: 'Property-Based',
                component: PropertyBased
            },
            {
                path: 'linker-design',
                name: 'Linker-Design',
                component: LinkerDesign
            },
            {
                path:'GenDetail',
                name:'GenDetail',
                component:GenDetail
            }

        ]
    },
    {
        path: '/optimization',
        name: 'Optimization',
        component: Optimization,
        show: true,
        children: [
            {
                path: 'logP',
                name: 'logP',
                component: LogP
            },
            {
                path: 'hydrophilic',
                name: 'hydrophilic',
                component: Hydrophilic
            },
            {
                path: 'QED',
                name: 'QED',
                component: QED
            },
            {
                path: 'SA',
                name: 'SA',
                component: SA
            },
            {
                path: 'detail',
                name: 'Detail',
                component: Detail
            },
            {
                path: ':uuid',
                name: 'Result',
                component: Result
            }
        ]
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/tutorial',
        name: 'Tutorial',
        component: Tutorial
    },
    {
        path: '/generation/success',
        name: 'Success',
        component: Success
    },
    {
        path: '/generation/:uuid',
        name: 'genResult',
        component: GenResult
    },
]

const router = new VueRouter({
    routes,

    mode:'hash',

    // mode:'history',
    // base:'/AIDrugDesigner'
})

export default router
